let isDev = false;
let config = {
    dev: {
        newApiDomain: "https://nc-api-dev.proneai.co.kr",
        apiDomain: "https://api-dev.proneai.co.kr",
        bucketOption: {
            BucketName: "prone-dev",
            BucketRegion: "ap-northeast-2",
        },
        imageDomain: "https://image-dev.proneai.co.kr",
        videoBucketOption:'',

    },
    prod: {
         newApiDomain: "https://nc-api.proneai.co.kr",
        apiDomain: "https://nc-api.proneai.co.kr",
        bucketOption: {
            BucketName: "prone-prod",
            BucketRegion: "ap-northeast-2",
        },
        imageDomain: "https://image.proneai.co.kr",
        videoBucketOption:'',
    },
};

function getConfig(key = "apiDomain") {

    return isDev ? config.dev[key] : config.prod[key];
}

function setConfig(key, value) {
    if (isDev) {
        config.dev[key] = value;
    } else {
        config.prod[key] = value;
    }
}

let apiDomain = getConfig("apiDomain");
let newApiDomain = getConfig("newApiDomain");
let apiURL = `${getConfig("apiDomain")}/`;
let newApiURL = `${getConfig("newApiDomain")}/`;
let bucketOption = getConfig("bucketOption");
let videoBucketOption = getConfig("videoBucketOption");
let imageDomain = getConfig("imageDomain");
let localStorageKey = 'com.hamalab.prone-vue-admin'

function setterApiDomain(domain) {
    setConfig("apiDomain", domain);
    apiDomain = getConfig("apiDomain");
    newApiDomain = getConfig("newApiDomain");
    apiURL = `${getConfig("apiDomain")}/`;
    newApiURL = `${getConfig("newApiDomain")}/`;

    let devDomain = config.dev.newApiDomain;
    let prodDomain = config.prod.newApiDomain;
    if (devDomain == domain) {
        isDev = true;
    } else if (prodDomain == domain) {
        isDev = false;
    }
    bucketOption = getConfig("bucketOption");
    imageDomain = getConfig("imageDomain");
}

export {
    setterApiDomain,
    apiURL,
    apiDomain,
    newApiDomain,
    newApiURL,
    imageDomain,
    bucketOption,
    isDev,
    localStorageKey,
    videoBucketOption,
};

